<template>
  <div>
    <van-nav-bar :title="title" left-arrow @click-left="$router.back()" />
    <div v-if="kind === 'points' || kind === 'exchange'" class="balance">当前余额 {{ balance }}</div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-if="!loading && finished && list.length === 0" class="empty">暂无记录</div>
      <div v-for="(item, index) in list" :key="index" class="item">
        <div class="row">
          <span>{{ item.changeTypeName || item.itemDesc || item.consumeNo }}</span>
          <span :class="amountClass(item)">{{ amountText(item) }}</span>
        </div>
        <div class="sub">{{ item.createTime || item.consumeTime }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { listConsume, listPoints, listExchange, getProfile, money } from '../api'

export default {
  data() {
    return { list: [], pageNum: 1, loading: false, finished: false, balance: '0.00' }
  },
  computed: {
    kind() { return this.$route.meta.kind },
    title() { return this.$route.meta.title }
  },
  created() {
    if (this.kind === 'points' || this.kind === 'exchange') {
      getProfile().then(res => {
        const data = res.data || {}
        this.balance = money(this.kind === 'points' ? data.pointsBalance : data.exchangeBalance)
      })
    }
  },
  methods: {
    onLoad() {
      const params = { pageNum: this.pageNum, pageSize: 10 }
      const req = this.kind === 'consume' ? listConsume(params) : this.kind === 'points' ? listPoints(params) : listExchange(params)
      req.then(res => {
        const rows = res.rows || []
        this.list = this.list.concat(rows)
        this.pageNum += 1
        this.loading = false
        if (this.list.length >= (res.total || 0) || rows.length === 0) this.finished = true
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    amountText(item) {
      if (this.kind === 'consume') return '+' + money(item.points)
      const value = Number(item.changeValue || 0)
      return (value > 0 ? '+' : '') + money(value)
    },
    amountClass(item) {
      if (this.kind === 'consume') return 'plus'
      return Number(item.changeValue || 0) >= 0 ? 'plus' : 'minus'
    }
  }
}
</script>

<style scoped>
.balance { padding: 12px 16px; background: #fff; margin-bottom: 8px; }
.item { background: #fff; padding: 12px 16px; border-bottom: 1px solid #f2f3f5; }
.row { display: flex; justify-content: space-between; }
.sub { color: #999; font-size: 12px; margin-top: 6px; }
.plus { color: #1f6f5b; }
.minus { color: #ee0a24; }
.empty { text-align: center; color: #999; padding: 40px 0; }
</style>
